import { AutoRegisterClass } from '../../services/generics/classRegistry';
import { Padrao } from '../generic/padrao';
import { Pessoa } from '../pessoa/pessoa';

@AutoRegisterClass()
export class PessoaCatalogo extends Padrao{

    override idTab = 268;

    pessoa: Pessoa = new Pessoa();
    nome: string;
    cpf: string;
    telefone: string;
}
